require('./storefront');

import Vue from 'vue';
import * as Sentry from "@sentry/vue";
import AddToHomeScreen from "a2hs.js";
import store from './store';
import { notify, trans, chunk, showComparisonButton } from './functions';
import VueToast from 'vue-toast-notification';
import vClickOutside from 'v-click-outside';
import VPagination from './components/VPagination.vue';
import HeaderSearch from './components/layout/HeaderSearch.vue';
import SidebarCart from './components/layout/SidebarCart';
import NewsletterPopup from './components/layout/NewsletterPopup';
import NewsletterSubscription from './components/layout/NewsletterSubscription';
import CookieBar from './components/layout/CookieBar';
import LandscapeProducts from './components/LandscapeProducts.vue';
import DynamicTab from './components/home/DynamicTab';
import HomeFeatures from './components/home/HomeFeatures.vue';
import FeaturedCategories from './components/home/FeaturedCategories.vue';
import BannerThreeColumnFullWidth from './components/home/BannerThreeColumnFullWidth.vue';
import ProductTabsOne from './components/home/ProductTabsOne.vue';
import TopBrands from './components/home/TopBrands.vue';
import FlashSaleAndVerticalProducts from './components/home/FlashSaleAndVerticalProducts.vue';
import FlashSale from './components/home/FlashSale.vue';
import BannerTwoColumn from './components/home/BannerTwoColumn.vue';
import VerticalProducts from './components/home/VerticalProducts.vue';
import ProductGrid from './components/home/ProductGrid.vue';
import BannerThreeColumn from './components/home/BannerThreeColumn.vue';
import BannerOffers from './components/home/BannerOffers.vue';
import ProductTabsTwo from './components/home/ProductTabsTwo.vue';
import BannerOneColumn from './components/home/BannerOneColumn.vue';
import ProductIndex from './components/products/Index';
import ProductCardGridView from './components/products/index/ProductCardGridView.vue';
import ProductCardListView from './components/products/index/ProductCardListView.vue';
import ProductCardVertical from './components/ProductCardVertical.vue';
import ProductShow from './components/products/Show';
import CartIndex from './components/cart/Index';
import CheckoutCreate from './components/checkout/Create';
import CompareIndex from './components/compare/Index';
import MyWishlist from './components/account/wishlist/Index';
import MyAddresses from './components/account/addresses/Index';

Vue.prototype.route = route;
Vue.prototype.$notify = notify;
Vue.prototype.$trans = trans;
Vue.prototype.showComparisonButton = showComparisonButton;
Vue.prototype.$chunk = chunk;

Vue.use(VueToast);
Vue.use(vClickOutside);

Vue.component('v-pagination', VPagination);
Vue.component('header-search', HeaderSearch);
Vue.component('sidebar-cart', SidebarCart);
Vue.component('newsletter-popup', NewsletterPopup);
Vue.component('newsletter-subscription', NewsletterSubscription);
Vue.component('cookie-bar', CookieBar);
Vue.component('landscape-products', LandscapeProducts);
Vue.component('dynamic-tab', DynamicTab);
Vue.component('home-features', HomeFeatures);
Vue.component('featured-categories', FeaturedCategories);
Vue.component('banner-three-column-full-width', BannerThreeColumnFullWidth);
Vue.component('product-tabs-one', ProductTabsOne);
Vue.component('top-brands', TopBrands);
Vue.component('flash-sale-and-vertical-products', FlashSaleAndVerticalProducts);
Vue.component('flash-sale', FlashSale);
Vue.component('banner-two-column', BannerTwoColumn);
Vue.component('vertical-products', VerticalProducts);
Vue.component('product-grid', ProductGrid);
Vue.component('banner-three-column', BannerThreeColumn);
Vue.component('banner-offers', BannerOffers);
Vue.component('product-tabs-two', ProductTabsTwo);
Vue.component('banner-one-column', BannerOneColumn);
Vue.component('product-index', ProductIndex);
Vue.component('product-card-grid-view', ProductCardGridView);
Vue.component('product-card-list-view', ProductCardListView);
Vue.component('product-card-vertical', ProductCardVertical);
Vue.component('product-show', ProductShow);
Vue.component('cart-index', CartIndex);
Vue.component('checkout-create', CheckoutCreate);
Vue.component('compare-index', CompareIndex);
Vue.component('my-wishlist', MyWishlist);
Vue.component('my-addresses', MyAddresses);

new Vue({
    el: '#app',

    computed: {
        cart() {
            return store.state.cart;
        },

        wishlistCount() {
            return store.wishlistCount();
        },

        canGoBack() {
            return window.history.length > 2 && document.location.pathname.length > 3;
        },

        goBack(){
            window.history.back();
        }

    },
    methods: {
        prev() {
            if (window.history.length > 2) {
                // if history is not empty, go back:
                window.history.back();
            }
        },
    }
});

Sentry.init({
    Vue: Vue,
    dsn: "https://d9decdb62cc94594a0e7981a28378304@o64693.ingest.sentry.io/5627604",
});
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': AianCart.csrfToken,
    },
});

AddToHomeScreen({
    brandName: AianCart.storeName,
    fontFamily: "Tahoma, sans-serif",
    htmlContent:`${AianCart.langs['storefront::layout.install_in_ios']}`,
    logoImage:`<svg enable-background="new 0 0 1952.00 734.93" height="45" viewBox="166.386 190.518 170.568 170.568" width="100" xmlns="http://www.w3.org/2000/svg">
    <defs>
    <radialGradient id="gradient-1-0" gradientUnits="userSpaceOnUse" cx="192.158" cy="240.658" r="85.284" gradientTransform="matrix(1, 0, 0, 1, 59.512119, 35.144173)" xlink:href="#gradient-1"/>
    <linearGradient id="gradient-1" bx:pinned="true">
      <stop offset="0" style="stop-color: rgb(194, 217, 114);"/>
      <stop offset="1" style="stop-color: rgb(147, 200, 84);"/>
    </linearGradient>
  </defs>
  <circle style="stroke-miterlimit: 1; stroke-dashoffset: 5px; paint-order: fill; stroke: rgb(200, 255, 0); stroke-width: 0px; fill: url(#gradient-1-0);" cx="251.67" cy="275.802" r="85.284"/>
  <path style="stroke: rgb(0, 0, 0); stroke-width: 0px; fill: rgb(255, 255, 255);" d="M 247.944 230.175 C 248.522 226.34 256.148 222.842 252.208 217.489 C 246.72 210.033 234.956 206.558 226.853 212.857 C 224.932 214.35 223.187 216.033 222.967 217.554 C 222.541 220.51 223.637 221.515 226.185 224.382 C 227.367 225.713 230.015 226.945 231.304 228.684 C 232.795 230.698 232.857 233.222 232.995 234.654 C 233.218 236.958 233.048 240.055 231.124 241.341 C 225.611 245.027 218.625 233.132 213.671 242.271 C 210.556 248.018 210.403 257.036 215.208 262.15 C 215.906 262.893 217.6 264.271 220.056 264.325 C 223.114 264.391 227.304 261.884 229.943 262.056 C 231.936 262.186 232.883 264.696 232.711 266.166 C 232.21 270.442 230.704 274.539 229.668 278.717 C 229.121 280.922 227.194 283.177 227.961 285.315 C 231.031 293.877 246.32 295.543 250.838 287.982 C 251.619 286.676 251.779 284.695 251.454 282.881 C 251.068 280.724 249.36 278.861 248.815 276.682 C 247.018 269.502 247.095 235.813 247.944 230.175 Z"/>
  <path style="stroke: rgb(0, 0, 0); stroke-width: 0px; fill: rgb(255, 255, 255);" d="M 286.232 320.759 C 286.81 324.594 292.528 331.872 288.588 337.225 C 283.1 344.681 270.534 344.13 262.431 337.831 C 260.51 336.338 259.952 336.171 259.732 334.65 C 259.306 331.694 262.783 329.455 265.548 327.594 C 267.025 326.6 268.521 325.088 269.81 323.349 C 271.301 321.335 270.645 317.818 270.783 316.386 C 271.006 314.082 270.834 311.967 268.91 310.681 C 263.397 306.995 258.626 320.69 251.959 308.663 C 248.79 302.946 248.691 293.898 253.496 288.784 C 254.194 288.041 255.888 286.663 258.344 286.609 C 261.402 286.543 265.008 291.16 267.638 290.881 C 270.371 290.591 271.171 286.238 270.999 284.768 C 270.498 280.492 270.328 279.564 269.292 275.386 C 268.745 273.181 264.903 268.917 265.67 266.779 C 268.74 258.217 284.319 257.183 289.126 262.952 C 290.1 264.121 290.482 267.226 290.157 269.04 C 289.771 271.197 288.063 273.06 287.518 275.239 C 285.721 282.419 285.383 315.121 286.232 320.759 Z" transform="matrix(-1, 0, 0, -1, 539.983276, 602.022522)"/>
  <path style="stroke: rgb(0, 0, 0); stroke-opacity: 0; fill: rgb(242, 235, 81);" d="M 282.896 264.869 C 289.42 263.274 296.416 264.945 301.706 268.958 C 303.535 270.346 308.202 275.454 305.623 278.283 C 303.008 281.151 299.503 283.412 289.641 274.258 C 286.879 271.694 284.314 268.404 282.896 264.869 Z"/>
  <path style="stroke: rgb(0, 0, 0); stroke-opacity: 0; fill: rgb(242, 235, 81);" d="M 196.701 233.794 C 200.073 233.507 202.536 233.295 205.49 232.574 C 209.383 231.623 209.808 230.872 214.186 228.808 C 215.071 228.391 217.386 226.342 218.077 224.493 C 218.91 222.266 218.016 220.222 217.944 220.119 C 217.019 218.797 211.824 214.99 201.962 224.144 C 199.2 226.708 198.119 230.259 196.701 233.794 Z" transform="matrix(-1, 0, 0, -1, 415.130768, 451.996582)"/>
</svg>`
});
